module.exports = __webpack_public_path__ + "img/image_placeholder.a5665b1d.png";